import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "date-selector" }
const _hoisted_2 = { class: "date-selector__current-date" }
const _hoisted_3 = { class: "date-selector__past--desktop" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ← ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Previous month")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "date-selector__separator" }, "·", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Previous day")
const _hoisted_8 = { class: "date-selector__past--mobile" }
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", { class: "date-direction-label" }, "← Past", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Previous day")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Previous month")
const _hoisted_12 = { class: "date-selector__future--desktop" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Next day")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "date-selector__separator" }, "·", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Next month")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" → ")
const _hoisted_17 = { class: "date-selector__future--mobile" }
const _hoisted_18 = /*#__PURE__*/_createVNode("strong", { class: "date-direction-label" }, "Future →", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Next day")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Next month")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_date_link_or_text = _resolveComponent("date-link-or-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.formattedDate), 1),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_date_link_or_text, { date: _ctx.previousMonth }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["date"]),
      _hoisted_6,
      _createVNode(_component_date_link_or_text, { date: _ctx.previousDay }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["date"])
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_date_link_or_text, { date: _ctx.previousDay }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["date"]),
      _createVNode(_component_date_link_or_text, { date: _ctx.previousMonth }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["date"])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_date_link_or_text, { date: _ctx.nextDay }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["date"]),
      _hoisted_14,
      _createVNode(_component_date_link_or_text, { date: _ctx.nextMonth }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["date"]),
      _hoisted_16
    ]),
    _createVNode("div", _hoisted_17, [
      _hoisted_18,
      _createVNode(_component_date_link_or_text, { date: _ctx.nextDay }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["date"]),
      _createVNode(_component_date_link_or_text, { date: _ctx.nextMonth }, {
        default: _withCtx(() => [
          _hoisted_20
        ]),
        _: 1
      }, 8, ["date"])
    ])
  ]))
}